export const storageData = {

    rememberMe: true,


    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZXNzaW9uSWQiOiJDMDk1NkRDM0MxREQ0N0JCOTlCQjIwRTIwODVFOTFBMiIsImlhdCI6MTc1Njk2NTI3NCwiZXhwIjoxNzU5NTU3Mjc0fQ.3UmXP_5z52Hdha7JE999Rl-e1j9ANMbvyK0VyE76M2Y',

    passportToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjdiZWQ1YjA2Y2JiOGQzZTgyNDE1OWE1ZGU3NGI3ZmMwOjU3YWM1ZTU5YWJjNzdlOTI5ODVlMGE4NzM4ZDM0OGE4Njk0ZGU2NjA0YzAyZDI4OTA0Njk4MGY2MzU1MDc0MjQxZTIzYWJlMGIwNGJkZDk0YTlkMzVjNjg4YzkwNTFhZCIsImlhdCI6MTc1Njk2NTI3NSwiZXhwIjoxNzY0NzQxMjc1fQ.zfkf1yjcHKBE_iqoUU2xUpMp-0SeeqEVUI1TT1vKwTQ',


    currentUser: {
        fullName: 'Fusion Suite',
        email: 'demoaccount@o3interfaces.com',
        kuid: 'E4CEF84DCC024F4C9222C549C9CE423F',
        avatar: 'https://fusionsuite-media.s3.amazonaws.com/avatar_708E1B1A185447EAA9D333A6428F088E_profile.jpeg?t=1778745366501',
        workspaceDetail: {},
        enterprise: false,
        enviornmentModel: 'cloud'
    },

    firebaseToken: undefined,

    trial_billing_info: {},

    owned_workspaces: 2,

    shared_workspaces: 0,


    lastVisited_workspace: {
        total_projects_count: 2,
        web_projects_count: 1,
        ios_projects_count: 0,
        android_projects_count: 1,
        member_role_type: 'owner',
        member_role_kuid: '',
        ws_kuid: '41989395a1ee48adbdd0b03631bccd09',
        ws_title: 'Fusion',
        ws_avatarColor: '#154299',
        ws_avatar: '',
        space_type: 'fusion',
        ws_isActive: 1,
        owner_kuid: 'E4CEF84DCC024F4C9222C549C9CE423F',
        owner_name: 'Fusion Suite',
        owner_avatar: 'https://fusionsuite-media.s3.amazonaws.com/avatar_E4CEF84DCC024F4C9222C549C9CE423F_Fusion-Suite-Logo---IG-FB-X-LI.jpg',
        ws_members: 2,
        ws_type: 'owned'
    },

    userWorkSpaceRole: {
        isOwner: true,
        userProjectRoles: []
    },

    UblDashboardPayloadData: [
        {
            dManifestId: 3,
            workspace_kuid: '41989395a1ee48adbdd0b03631bccd09',
            project_kuid: '96AFFCB5470446E9B278995DE3E5DFC4',
            createdAt: '2024-02-14T06:13:58.000Z',
            isActive: 1,
            is_sdk_integrated: 1,
            platformType: 'android'
        },
        {
            dManifestId: 5,
            workspace_kuid: '41989395a1ee48adbdd0b03631bccd09',
            project_kuid: '768399791ED64E43BBFCA34E3A85F940',
            createdAt: '2025-02-17T06:18:33.000Z',
            isActive: 1,
            is_sdk_integrated: 1,
            platformType: 'ios'
        }
    ],

    userProjectRole: {
        userProjectRole: [],
        isOwner: true
    },

    selectedProject: {
        p_title: 'Demo',
        p_kuid: '96AFFCB5470446E9B278995DE3E5DFC4',
        p_platformType: 'android',
        p_appIdIdentifier: 'com.account.demo',
        p_environment: 'sandbox',
        p_avatar: null,
        p_member_role_type: 'owner',
        p_member_role_kuid: '',
        p_operation_mode: 'sdk_project',
        is_sdk_integrated: true,
        sdk_operations: 'Enable',
        sdk_integrated_on: '2025-02-14T07:13:31.000Z',
        numer_of_releases: 12,
        p_members: 1,
        is_css_integrated: true,
        css_ccm_workspace_kuid: "276c4c83f91947889a04d7d29d7eb57e"
    }
};


export const setting_access_not_allowed_emails = ['demoaccount@o3interfaces.com'];

export function initializeSandboxStorage(): void {
    Object.entries(storageData).forEach(([key, value]) => {
        if (value !== undefined) {
            localStorage.setItem(key, JSON.stringify(value));
        }
    });
}